import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {IMessengerConnector, Message} from '../../../../types/all.type';
import {VkService} from '../../../../pages/page-vk/vk.service';
import {from, Subject, Subscription, takeUntil} from 'rxjs';
import {DatePipe} from '@angular/common';
import {AllService} from '../../../../services/all.service';
import {AppService} from "../../../../services/app.service";
import {distinctUntilChanged} from "rxjs/operators";
import {UnsubscriberService} from '../../../../services/unsubscriber.service';

@Component({
  selector: 'app-message-attachments-compact',
  templateUrl: './message-attachments-compact.component.html',
  styleUrls: ['./message-attachments-compact.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageAttachmentsCompactComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  @Input() message: Message;
  @Input() Service: IMessengerConnector;
  @Input() lvl = 1;
  public attachment: any;

  constructor(
    private datePipe: DatePipe,
    public appService: AppService,
    private allService: AllService,
    private cd: ChangeDetectorRef
  ) {
    this.cd.detach();
  }

  ngOnInit(): void {
    if (this.message.attachments?.length > 0) this.attachment = this.message.attachments[0];

    if (this.attachment.file_size) {
      this.attachment.file_size_convert = this.appService.bytesToSize(this.attachment.file_size);
    }
    if (this.attachment.file_uri) {
      this.attachment.name = this.allService.basename(this.attachment.file_uri, '');
    }
    switch (this.attachment.type) {
      case 'video_note':
        this.attachment.compact_title = 'Видеосообщение';
        if (this.attachment?.duration) {
          this.attachment.compact_description = this.attachment?.duration + ' сек.';
        } else {
          this.attachment.compact_description = this.attachment?.file_size_convert;
        }
        break;
      case 'animation':
        this.attachment.compact_title = 'GIF';
        break;
      case 'audio':
        this.attachment.compact_title = this.attachment?.performer || 'Аудио';
        this.attachment.compact_description = this.attachment?.title || this.attachment?.duration + ' сек.';
        break;
      case 'photo':
        this.attachment.compact_description = 'Фото ' + this.attachment?.file_size_convert;
      case 'document':
        this.attachment.compact_description = 'Документ ' + this.attachment?.file_size_convert;
      case 'video_iframe':
      case 'gift':
        if (!this.attachment?.thumb?.file_uri && this.attachment?.thumb?.file_id) {
          if (!(this.Service instanceof VkService)) {
            this.Service.getFile$(this.attachment.thumb.file_id, this.attachment.thumb.file_unique_id)
              .pipe(takeUntil(this.destroy$))
              .subscribe((result: any) => {
                // tag("getFile$")
                this.attachment.thumb.file_uri = result.file;
                // alert(result.file);
                this.cd.detectChanges();
              })
          }
        }
        break;

      case 'location':
        this.attachment.compact_title = 'Геопозиция';
        this.attachment.compact_description = `${this.attachment.longitude},${this.attachment.latitude}`;
        this.attachment.thumb.file_uri = `https://static-maps.yandex.ru/1.x/?ll=${this.attachment.longitude},${this.attachment.latitude}&size=250,250&z=13&l=map&pt=${this.attachment.longitude},${this.attachment.latitude},comma`;
        break;
      case 'wall':
        this.attachment.compact_title = 'Запись';
        const date = this.datePipe.transform(this.attachment?.wall?.date * 1000, 'd MMMM YYYY');
        this.attachment.compact_description = this.attachment?.wall?.text || 'от ' + date;
        break;
      case 'web_page':
        this.attachment.compact_title = this.attachment?.title || this.attachment.url;
        this.attachment.compact_description = this.attachment?.description || 'Ссылка';
        break;
    }

    this.cd.detectChanges();
  }

  trackByFn(index, element: any) {
    return element ? element.id : undefined;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
